import {
  Button,
  Col,
  Form,
  Input,
  PageHeader,
  Row,
  Select,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import IconShop from "../../static/icon/IconShop";
import { useAuth } from "../../context/auth";
import ProvinceDropdown from "../Dropdown/ProvinceDropdown";

const MerchantSetting = ({ match: { params: { id } } }) => {
  const history = useHistory();
  const { accessToken } = useAuth();

  const [form] = Form.useForm();

  const [change, setChange] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (id === 'new') return;

    async function getMerchant() {
      const url = new URL('/api/merchant/' + id, window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { merchant } = await res.json();
        form.setFieldsValue(merchant);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    setChange(false);
    getMerchant();
  }, [accessToken, form, id]);

  const save = async (values) => {
    setDisabled(true);
    setChange(false);

    const url = new URL(id === 'new' ? '/api/merchant' : '/api/merchant/' + id, window.location);

    const res = await fetch(url, {
      method: id === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      history.push({
        pathname: "/merchant",
        searchValue: history.location.searchValue,
        pageValue: history.location.pageValue,
      });
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setDisabled(false);
    setChange(true);
  };

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconShop /> &nbsp;&nbsp;Cluster Setting
            </span>
          }
        />
      </div>
      <div className="content">
        <div className="search">
          <Form
            form={form}
            onFinish={save}
            onFieldsChange={() => setChange(true)}
            className="search_inline row mt-3"
            style={{ display: "inline-grid", margin: "auto", width: "80%" }}
          >
            <Row gutter={40} style={{ marginTop: 30 }}>
              <Col sm={24} md={24} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Cluster Id"
                  name="id"
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Auto generate"
                    maxLength={50}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={40} style={{ marginTop: 30 }}>
              <Col sm={24} md={24} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Cluster Name (EN)"
                  name="nameEn"
                  rules={[
                    {
                      required: true,
                      message: "Cluster Name (EN) is required.",
                    },
                  ]}
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Cluster Name (EN)"
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Cluster Name (TH)"
                  name="nameTh"
                  rules={[
                    {
                      required: true,
                      message: "Cluster Name (TH) is required.",
                    },
                  ]}
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Cluster Name (TH)"
                    maxLength={50}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 15 }}>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Area Type"
                  name="internal"
                  rules={[
                    {
                      required: true,
                      message: "Area Type is required.",
                    },
                  ]}
                  colon={false}
                  className="mt-2"
                >
                  <Select
                    placeholder="Area Type"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    <Select.Option value={false}>
                      Public Used
                    </Select.Option>
                    <Select.Option value={true}>
                      Internal Used
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <div className="flex items-center -mx-2.5 mb-2">
              <div className="flex-1 border-b border-gray-300" />
              <span className="px-2.5 pb-1 font-black">
                Other Infomation
              </span>
              <div className="flex-1 border-b border-gray-300" />
            </div>

            <Row gutter={40} style={{ marginTop: 20 }}>
              <Col sm={24} md={24} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Address (EN)"
                  name="addrEn"
                  colon={false}
                  className="mt-2"
                >
                  <Input.TextArea
                    placeholder="Address (EN)"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Address (TH)"
                  name="addrTh"
                  colon={false}
                  className="mt-2"
                >
                  <Input.TextArea
                    placeholder="Address (TH)"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    maxLength={255}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={40} style={{ marginTop: 15 }}>
              <Col sm={24} md={24} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Province"
                  name="provinceId"
                  colon={false}
                  className="mt-2"
                >
                  <ProvinceDropdown />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={40} style={{ marginTop: 15 }}>
              <Col sm={24} md={24} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Taxpayer Identification No."
                  name="taxId"
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Taxpayer Identification No."
                    maxLength={13}
                  />
                </Form.Item>
              </Col>
              <Col sm={24} md={24} lg={12}>
                <Form.Item
                  label="Tel"
                  name="tel"
                  colon={false}
                  className="mt-2"
                >
                  <Input
                    placeholder="Tel"
                    maxLength={13}
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="w-full text-center flex justify-center space-x-4">
              <Button
                className="w-36"
                type="primary"
                ghost
                shape="round"
                htmlType="button"
                onClick={() => {
                  history.push({
                    pathname: "/merchant",
                    searchValue: history.location.searchValue,
                    pageValue: history.location.pageValue,
                  });
                }}
              >
                Cancel
              </Button>
              <Button
                className="w-36"
                key="save"
                type="primary"
                shape="round"
                htmlType="submit"
                disabled={disabled}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <Prompt when={change} message="Changes will not be saved. Do you want to proceed ?" />
    </>
  );
};
export default MerchantSetting;
